import Vue from 'vue';

Vue.component('time-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            timer: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.interval = () => {
            let date = new Date();
            date = date.toLocaleString('nl-NL', {
                hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Europe/Amsterdam',
            });
            document.getElementById('timezone-time').innerHTML = date;
        };

        this.setDate();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        setDate() {
            this.interval();
            this.timer = setInterval(this.interval, 10000);
        },
    },

    beforeDestroy() {
        clearInterval(this.timer);
    },
});
